import logoBlueRound from './logoBlueRound.svg';
import logoWhiteeRound from './logoWhiteRound.svg';
import logoDarkRound from './logoDarkRound.svg';
import homeHero from './homeHero.webp';
import tn1 from './tn1.svg';
import tn2 from './tn2.svg';
import tn3 from './tn3.svg';
import tn4 from './tn4.svg';
import tn5 from './tn5.svg';
import navLogo from './Untitled.svg';
import buildingAutomationServices from './buildingAutomationServices.webp';
import buildingAutomationServicesNew from './buildingAutomationServices_1.webp';
import hvac_ from './hvac_.webp';
// import clearView from './clearView.webp'
// import richView from './richView.webp'
import pv from './pv.webp';
import buildingAutomation from './service_BuildingAutomation.webp';
import hvacService from './service_hvac.webp';
import insulationService from './service_Insulation.webp';
import plumbingService from './service_plumbing.jpg';
import scopeOfWork from './scopeOfWork.svg';
import gear from './gears-solid.svg';
// import vaughanFireStation from './vaughanFireStation.webp'
// import winterAndWaniers from './winterAndWaniers.webp'

import clearView from './project-images/clearView.webp';
import richView from './project-images/richView.webp';
import vaughanFireStation from './project-images/vaughanFireStation.webp';
import winterAndWaniers from './project-images/winterAndWaniers.webp';
import bialikHebrew from './project-images/bialikHebrew.webp';
import allSaints from './project-images/allSaints.webp';
import churchillMeadow from './project-images/churchillMeadow.webp';
import countrySideVillageSchool from './project-images/countrySideVillageSchool.webp';
import ecole from './project-images/ecole.webp';
import ecoleDyane from './project-images/ecoleDyane.webp';
import fairview from './project-images/fairview.webp';
import fatherMicheal from './project-images/fatherMicheal.webp';
import grandValley from './project-images/grandValley.webp';
import grandValleyInstitute from './project-images/grandValleyInstitute.jpg';
import huttonville from './project-images/huttonville.webp';
import jamesPotter from './project-images/jamesPotter.webp';
import jefferson from './project-images/jefferson.webp';
import keaton from './project-images/keaton.webp';
import mayfairClub from './project-images/mayfairClub.webp';
import mundenPark from './project-images/mundenPark.webp';
import northOshwaEMS from './project-images/northOshwaEMS.webp';
import norton from './project-images/norton.webp';
import oscarPeterson from './project-images/oscarPeterson.webp';
import ruthThompson from './project-images/ruthThompson.webp';
import southMeadowsElementary from './project-images/southMeadowsElementary.webp';
import stJohnPaul from './project-images/stJohnPaul.webp';
import stSebastian from './project-images/stSebastian.webp';
import thatamHall from './project-images/thatamHall.webp';
import thorndale from './project-images/thorndale.webp';
import vaughanFireStation73 from './project-images/vaughanFireStation73.webp';
import clarksonSecondary from './project-images/clarksonSecondary.webp';
import bradfordCommHub from './project-images/bradfordCommHub.webp';
import garnetWilliams from './project-images/garnetWilliams.jpg';
import playfair from './project-images/playfair60.webp';
import stLeoCatholic from './project-images/stLeoCatholicSchool.webp';
// import yorkLaPs from './project-images/yorkLaPs.webp';
import york from './project-images/york.webp';
import HollywoodPublicSchool from './project-images/HollywoodPublicSchool.webp';
import DanteAlighieri from './project-images/DanteAlighieri.webp';
import customerFocus from './customerFocus.svg';
import excellence from './excellence.svg';
import integrity from './integrity.svg';
import innovation from './innovation.svg';
import elmDrive from './project-images/elmDrive.webp';

const images = {
    navLogo,
    logoBlueRound,
    logoWhiteeRound,
    logoDarkRound,
    homeHero,
    tn1,
    tn2,
    tn3,
    tn4,
    tn5,
    buildingAutomationServices,
    buildingAutomationServicesNew,
    hvac_,
    pv,
    buildingAutomation,
    hvacService,
    insulationService,
    plumbingService,
    scopeOfWork,
    gear,

    clearView,
    richView,
    vaughanFireStation,
    winterAndWaniers,
    bialikHebrew,
    allSaints,
    churchillMeadow,
    countrySideVillageSchool,
    ecole,
    ecoleDyane,
    fairview,
    fatherMicheal,
    grandValley,
    grandValleyInstitute,
    huttonville,
    jamesPotter,
    jefferson,
    keaton,
    mayfairClub,
    mundenPark,
    northOshwaEMS,
    norton,
    oscarPeterson,
    ruthThompson,
    southMeadowsElementary,
    stJohnPaul,
    stSebastian,
    thatamHall,
    thorndale,
    vaughanFireStation73,
    clarksonSecondary,
    bradfordCommHub,
    garnetWilliams,
    playfair,
    stLeoCatholic,
    // yorkLaPs,
    york,
    HollywoodPublicSchool,
    DanteAlighieri,
    elmDrive,

    customerFocus,
    excellence,
    integrity,
    innovation,
};

export default images;
